<template>
  <a-card :bordered='false'>
    <a-button class="m-b-20" type="primary" v-has:SigncontractAdd="()=>{$router.push('/guide/Signcontract/sing_Create?type=add')}">
      <PlusOutlined />
      创建签约任务
    </a-button>
    <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:250px" placeholder="请输入任务标题" />
      </a-form-item>
      <a-form-item label="状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="任务状态" name='task_status'>
        <a-select v-model:value="search.task_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">未开始</a-select-option>
          <a-select-option :value="2">进行中</a-select-option>
          <a-select-option :value="3">已结束</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="参与类型" name='range_type'>
        <a-select v-model:value="search.range_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="2">门店</a-select-option>
          <a-select-option :value="1">经销商</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      <template v-slot:participation="{ record }">
        <a-button type="link" size="small" @click="scopePart(record)"> 查看</a-button>
      </template>
      <template v-slot:status="{ record }">
        <p v-if="record.status==1">启用</p>
        <p v-else>禁用</p>
      </template>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a-button type="link" size="small" v-has:SigncontractEdit="()=>{$router.push('/guide/Signcontract/sing_Edit?type=edit&id='+record.id)}">编辑</a-button>
              </a-menu-item>
              <a-menu-item v-if="record.status==1">
                <a-button type="link" size="small" v-has:SigncontractDisable="()=>disBtn(record)">禁用</a-button>
              </a-menu-item>
              <a-menu-item v-if="record.status==0">
                <a-button type="link" size="small" v-has:SigncontractDisable="()=>disBtn(record)">启用</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button type="link" size="small" v-has:SigncontractData="()=>{$router.push('/guide/Signcontract/dataStatistics?type='+record.range_type+'&id='+record.id+'&name='+record.name)}">数据</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button type="link" size="small" v-has:SigncontractData="()=>delBtn(record)">删除</a-button>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal :keyboard="false" title="参与范围" v-model:visible="showscpoe" centered :width='1200' destroyOnClose :footer="null">
    <scope :id="id" :range_type='range_type'></scope>
  </a-modal>
</template>
<script>
import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getcontractingList,
  delcontracting,
  editcontractingstatus,
} from "@/api/guide";
import { iscode } from "@/utils/app";
import scope from "./scopeparticipation.vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  keyword: "",
  status: "",
  type: 1,
  task_status: "",
  range_type: "",
};
export default {
  components: {
    DownOutlined,
    PlusOutlined,
    scope,
  },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 0,
      range_type: "",
      id: "",
      showscpoe: false,
    });
    let columns = [
      {
        title: "标题",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "时间要求",
        dataIndex: "start_time",
        key: "start_time",
        customRender: ({ record }) => {
          return record.start_time + "至" + record.end_time;
        },
      },
      // {
      //   title: "任务量",
      //   dataIndex: "task_number",
      //   key: "task_number",
      //   customRender: ({ record }) => {
      //     return record.task_number ? record.task_number : "-";
      //   },
      // },
      {
        title: "参与类型",
        dataIndex: "range_type_text",
        key: "range_type_text",
      },
      {
        title: "参与范围",
        dataIndex: "participation",
        key: "participation",
        slots: { customRender: "participation" },
      },
      {
        title: "任务状态",
        dataIndex: "task_status_text",
        key: "task_status_text",
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        slots: { customRender: "status" },
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //删除
    const delBtn = (e) => {
      $Modal.confirm({
        title: "提示",
        content: "删除后不可恢复且在渠道不可见，确定删除吗？",
        centered: true,
        onOk: async () => {
          let res = await delcontracting({id:e.id})
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            message.success(res.message);
            initData();
          } else {
            message.error(res.message);
          }
        },
      });
    };
    //查看
    const scopePart = (e) => {
      console.log(111);
      state.showscpoe = true;
      state.id = e.id;
      state.range_type = e.range_type;
    };

    //禁用
    const disBtn = (e) => {
      if (e.status == 1) {
        $Modal.confirm({
          title: "提示",
          content: "禁用后在渠道不可见，确定禁用吗？",
          centered: true,
          onOk: async () => {
            let res = await editcontractingstatus({id:e.id})
              .then((res) => res.data)
              .catch((error) => error);
            if (iscode(res)) {
              message.success(res.message);
              initData();
            } else {
              message.error(res.message);
            }
          },
        });
      } else {
        $Modal.confirm({
          title: "提示",
          content: "确定启用该任务吗？",
          centered: true,
          onOk: async () => {
            let res = await editcontractingstatus({ id: e.id })
              .then((res) => res.data)
              .catch((error) => error);
            if (iscode(res)) {
              message.success(res.message);
              initData();
            } else {
              message.error(res.message);
            }
          },
        });
      }
    };
    //数据
    const dataBtn = (e) => {};
    const initData = async () => {
      state.listLoading = true;
      let res = await getcontractingList({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      delBtn,
      initData,
      disBtn,
      dataBtn,
      scopePart,
    };
  },
};
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>